import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  signOut(event) {
    if (!this.nativeAppAvailable()) return

    event.preventDefault()
    event.stopImmediatePropagation()
    window.TurboNativeBridge?.postMessage("signOut")
  }

  nativeAppAvailable() {
    const nativeUserAgent = /(Turbo|Hotwire) Native|BestFoodIos/.test(
      navigator.userAgent
    )
    const nativeHandler = Boolean(
      window.nativeApp || window.webkit?.messageHandlers?.nativeApp
    )

    return nativeUserAgent || nativeHandler
  }
}
